<template>
  <Teleport to="#modal-overlay">
    <Transition>
      <div v-if="isVisible" class="modal-overlay" @click="$emit('close')">
        <div class="modal-content" @click.stop>
          <!-- Slot for dynamic content -->
          <slot></slot>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script lang="ts" setup>
type Props = {
  isVisible: boolean
}
type Emits = {
  (e: 'close')
}
defineProps<Props>()
defineEmits<Emits>()
</script>

<style scoped>
.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10001;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  overflow-y: auto;
  margin: 20px;
}
.content {
  display: block;
  height: max-content;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.1s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
